import { setup } from './core/src/setup';
const config = require('./config.js');
setup(config.default);